export const checkValidZoom = (value: number) => {
  const percent = value * 100;
  return percent > 0.1 && percent < 1000;
};
